import React, { useMemo, useRef, useState } from "react";
import NeuralInterfaceContext from "./NeuralInterfaceContext";
import { createNewNodeSourceFile, createNewNodeSourceFileTable, createNewNodeSourceText, createNodeSourceMap } from "./CreateNodeSource";
import { METHOD_FILE_ID, METHOD_FILE_TABLE_ID, METHOD_TEXT_ID } from "./runMethod";
import toLower from "lodash/toLower";
function NeuralInterfaceContextProvider({ children, addOnGraph, saveFIle, voiceRecognize, runMethods }) {
    const [activeInput, setActiveInput] = useState("Input");
    const [recognizeText, setRecognizeText] = useState();
    const voiceRecorderRef = useRef(null);
    const toggleInputMode = () => {
        setActiveInput(prev => (prev === "Input" ? "Voice Recode" : "Input"));
    };
    const startVoiceRecording = () => {
        var _a;
        (_a = voiceRecorderRef.current) === null || _a === void 0 ? void 0 : _a.startRecording();
    };
    const stopVoiceRecording = () => {
        var _a;
        (_a = voiceRecorderRef.current) === null || _a === void 0 ? void 0 : _a.stopRecording();
        setActiveInput("Input");
    };
    const checkVoiceRecord = () => {
        var _a;
        (_a = voiceRecorderRef.current) === null || _a === void 0 ? void 0 : _a.stopRecording();
    };
    const addFile = (file) => {
        if (file) {
            saveFIle(file, data => {
                const isExcelFile = [".xlsx", ".xls", ".xlsm", ".xlsb"].includes(toLower(file.extension));
                const createMethod = isExcelFile ? createNewNodeSourceFileTable : createNewNodeSourceFile;
                const methodId = isExcelFile ? METHOD_FILE_TABLE_ID : METHOD_FILE_ID;
                const nodesSource = [createMethod({ fileLink: data, tempFileLink: data })];
                addOnGraph({
                    EdgesSource: {},
                    Groups: {},
                    NodesSource: createNodeSourceMap(nodesSource)
                }, () => {
                    runMethods([{ methodId, nodesSource }]);
                });
            });
        }
    };
    const addVoiceRecord = (file) => {
        var _a;
        if (file) {
            (_a = voiceRecorderRef.current) === null || _a === void 0 ? void 0 : _a.setShowProgress(true);
            voiceRecognize(file, data => {
                var _a;
                setRecognizeText(data);
                (_a = voiceRecorderRef.current) === null || _a === void 0 ? void 0 : _a.setShowProgress(false);
                toggleInputMode();
            });
        }
    };
    const addText = (text) => {
        if (text) {
            const nodesSource = [createNewNodeSourceText({ text, tempText: text })];
            addOnGraph({
                EdgesSource: {},
                Groups: {},
                NodesSource: createNodeSourceMap(nodesSource)
            }, () => {
                runMethods([{ methodId: METHOD_TEXT_ID, nodesSource }]);
            });
        }
    };
    const contextValue = useMemo(() => ({
        activeInput,
        toggleInputMode,
        startVoiceRecording,
        stopVoiceRecording,
        checkVoiceRecord,
        voiceRecorderRef,
        addOnGraph,
        saveFIle,
        addFile,
        addVoiceRecord,
        addText,
        recognizeText
    }), [
        activeInput,
        voiceRecorderRef,
        startVoiceRecording,
        stopVoiceRecording,
        startVoiceRecording,
        addOnGraph,
        saveFIle,
        recognizeText
    ]);
    return (React.createElement(NeuralInterfaceContext.Provider, { value: contextValue }, children));
}
export default NeuralInterfaceContextProvider;
